import MegaMenuDropdown from '@/components/common/navigation/MegaMenuDropdown';
import { PrimaryButtonLink } from '@/components/common/PrimaryButton';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { twMerge } from '@/lib/twMerge';
import { MegaMenuSection } from '@/types/mega-menu';
import { HeaderEnum } from '@/types/translations/HeaderEnum';
import { createHasBidUrl } from '@/utilites/search/create-search-urls';

type SellMegaMenuDropdownProps = {
  trigger: React.ReactNode;
  rootClassName?: string;
  navItemClassName?: string;
  triggerClassName?: string;
  contentClassName?: string;
  containerClassName?: string;
  panelClassName?: string;
  layoutClassName?: string;
  sectionClassName?: string;
  titleClassName?: string;
  descriptionClassName?: string;
  footerLinkClassName?: string;
  trailingContentClassName?: string;
};

export default function SellMegaMenuDropdown({
  trigger,
  rootClassName,
  navItemClassName,
  triggerClassName,
  contentClassName,
  containerClassName,
  panelClassName,
  layoutClassName,
  sectionClassName,
  titleClassName,
  descriptionClassName,
  footerLinkClassName,
  trailingContentClassName,
}: SellMegaMenuDropdownProps) {
  const { translate } = useTypedTranslation<HeaderEnum>('header');

  const sections: MegaMenuSection[] = [
    {
      id: 'sell-private',
      title: translate(HeaderEnum['sell_menu.private_title']),
      description: translate(HeaderEnum['sell_menu.private_description']),
      items: [],
      footerLink: {
        id: 'sell-private-cta',
        label: translate(HeaderEnum['sell_menu.private_cta']),
        href: '/sell#sell-by-yourself',
      },
    },
    {
      id: 'sell-professional',
      title: translate(HeaderEnum['sell_menu.professional_title']),
      description: translate(HeaderEnum['sell_menu.professional_description']),
      items: [],
      footerLink: {
        id: 'sell-professional-cta',
        label: translate(HeaderEnum['sell_menu.professional_cta']),
        href: '/auth/onboarding/seller/personal-information',
      },
    },
  ];

  return (
    <MegaMenuDropdown
      trigger={trigger}
      sections={sections}
      rootClassName={rootClassName}
      navItemClassName={navItemClassName}
      triggerClassName={triggerClassName}
      contentClassName={contentClassName}
      containerClassName={containerClassName}
      panelClassName={panelClassName}
      layoutClassName={layoutClassName}
      sectionClassName={sectionClassName}
      titleClassName={titleClassName}
      descriptionClassName={descriptionClassName}
      footerLinkClassName={footerLinkClassName}
      trailingContent={
        <aside
          className={twMerge(
            'tw-flex tw-w-[340px] tw-flex-shrink-0 tw-flex-col tw-gap-4',
            trailingContentClassName
          )}
        >
          <PrimaryButtonLink
            href={createHasBidUrl()}
            className="tw-h-auto tw-w-full !tw-max-w-none tw-flex-col tw-items-start tw-gap-1 !tw-rounded-3xl tw-px-6 tw-py-5 !tw-text-left !tw-shadow-none"
          >
            <span className="tw-text-sm tw-font-medium tw-leading-5 tw-text-white/80">
              {translate(HeaderEnum['sell_menu.direct_sell_title'])}
            </span>
            <span className="tw-text-[18px] tw-font-semibold tw-leading-7 tw-text-white">
              {translate(HeaderEnum['sell_menu.direct_sell_description'])}
            </span>
          </PrimaryButtonLink>

          <PrimaryButtonLink
            href="/sell"
            outlined={true}
            className="tw-h-auto tw-w-full !tw-max-w-none tw-flex-col tw-items-start tw-gap-1 !tw-rounded-3xl tw-px-6 tw-py-5 !tw-text-left !tw-shadow-none"
          >
            <span className="tw-text-sm tw-font-medium tw-leading-5 tw-text-main/80">
              {translate(HeaderEnum['sell_menu.valuation_title'])}
            </span>
            <span className="tw-text-[18px] tw-font-semibold tw-leading-7 tw-text-main">
              {translate(HeaderEnum['sell_menu.valuation_description'])}
            </span>
          </PrimaryButtonLink>
        </aside>
      }
    />
  );
}
